import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
  appName = 'Asha Sathi App';
  companyName = 'Velodynamics Pvt. Ltd.';
  email = 'info.velodynamics@gmail.com';
  address = '502, Emerald comer, 2nd lane, Rajarampuri, Kolhapur 416001'
}
